import { render, staticRenderFns } from "./AppFilterSectionReviewOptionTypeFilters.vue?vue&type=template&id=f0606d04&scoped=true"
import script from "./AppFilterSectionReviewOptionTypeFilters.vue?vue&type=script&lang=js"
export * from "./AppFilterSectionReviewOptionTypeFilters.vue?vue&type=script&lang=js"
import style0 from "./AppFilterSectionReviewOptionTypeFilters.vue?vue&type=style&index=0&id=f0606d04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0606d04",
  null
  
)

export default component.exports